<img class="inline-block mr-1" src="/assets/svg-icons/error.svg">
<span class="text-xs font-normal">
    <ng-content></ng-content>
</span>
